document.addEventListener('DOMContentLoaded', function () {
  const filterContainer = document.querySelector('.program-listing-filter');
  const searchInput = filterContainer.querySelector('input[type="text"]');
  const divisionSelect = filterContainer.querySelectorAll('select')[0];
  const degreeTypeSelect = filterContainer.querySelectorAll('select')[1];
  const programList = document.querySelector('.program-listing-stacked');
  const items = Array.from(programList.querySelectorAll('li'));

  function normalize(str) {
    return str.toLowerCase().trim();
  }

  function isAnyFilterActive() {
    return (
      normalize(searchInput.value) !== '' ||
      normalize(divisionSelect.value) !== '' ||
      normalize(degreeTypeSelect.value) !== ''
    );
  }

  function filterList() {
    const search = normalize(searchInput.value);
    const division = divisionSelect.value;
    const degree = degreeTypeSelect.value;

    const isSearchActive = search !== '';
    const isDivisionActive = division !== 'Filter by Division';
    const isDegreeActive = degree !== 'Filter by Degree Type';

    const isAnyFilterActive = isSearchActive || isDivisionActive || isDegreeActive;

    items.forEach(item => {
        const heading = normalize(item.querySelector('.program-listing-heading').textContent);
        const divisionText = item.querySelector('.program-listing-secondary').textContent.trim();
        const degreeText = item.querySelector('.program-listing-tertiary').textContent.trim();

        let match = true;

        if (isSearchActive) {
        match = heading.includes(search);
        }

        if (isDivisionActive) {
        match = match && divisionText === division;
        }

        if (isDegreeActive) {
        match = match && degreeText === degree;
        }

        item.style.display = isAnyFilterActive ? (match ? '' : 'none') : '';
    });
  }

  // Bind listeners
  searchInput.addEventListener('input', filterList);
  divisionSelect.addEventListener('change', filterList);
  degreeTypeSelect.addEventListener('change', filterList);

  // Initial load: show all
  items.forEach(item => item.style.display = '');
});